/* tslint:disable */
/* eslint-disable */
/**
 * BonusX - Auth Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminLogin401Response } from '../models';
// @ts-ignore
import type { AdminLoginRequest } from '../models';
// @ts-ignore
import type { AuthenticationBody } from '../models';
// @ts-ignore
import type { AuthenticationResponse } from '../models';
// @ts-ignore
import type { CheckExistingEmail400Response } from '../models';
// @ts-ignore
import type { InputAuthenticationRegister } from '../models';
// @ts-ignore
import type { InputChangePassword } from '../models';
// @ts-ignore
import type { InputCheckExistingEmail } from '../models';
// @ts-ignore
import type { InputSendForgotPasswordEmail } from '../models';
// @ts-ignore
import type { Message4xx } from '../models';
// @ts-ignore
import type { SendForgotPasswordEmail200Response } from '../models';
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin: async (adminLoginRequest?: AdminLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/adminLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (inputChangePassword?: InputChangePassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputChangePassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail: async (inputCheckExistingEmail?: InputCheckExistingEmail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/check-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCheckExistingEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/ability-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword: async (authenticationBody?: AuthenticationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/login/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin: async (adminLoginRequest?: AdminLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/magicLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (inputAuthenticationRegister?: InputAuthenticationRegister, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputAuthenticationRegister, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail: async (inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/send-forgot-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSendForgotPasswordEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/verify-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLogin(adminLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.adminLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationValidateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationValidateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationValidateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(inputChangePassword?: InputChangePassword, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(inputChangePassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExistingEmail(inputCheckExistingEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.checkExistingEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbilityRules(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbilityRules(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getAbilityRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithPassword(authenticationBody?: AuthenticationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithPassword(authenticationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async magicLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.magicLogin(adminLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.magicLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(inputAuthenticationRegister, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendForgotPasswordEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.sendForgotPasswordEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.verifyAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.adminLogin(adminLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authenticationValidateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inputChangePassword?: InputChangePassword, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.changePassword(inputChangePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules(options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAbilityRules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword(authenticationBody?: AuthenticationBody, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginWithPassword(authenticationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {AdminLoginRequest} [adminLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.magicLogin(adminLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse> {
            return localVarFp.register(inputAuthenticationRegister, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: RawAxiosRequestConfig): AxiosPromise<SendForgotPasswordEmail200Response> {
            return localVarFp.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.verifyAccount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {AdminLoginRequest} [adminLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    adminLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * Use this endpoint to check if the user is authenticated.
     * @summary Check user authentication status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationValidateGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary User can change password and login
     * @param {InputChangePassword} [inputChangePassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    changePassword(inputChangePassword?: InputChangePassword, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary User can load ability rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    getAbilityRules(options?: RawAxiosRequestConfig): AxiosPromise<Array<object>>;

    /**
     * 
     * @summary User can login through email and password
     * @param {AuthenticationBody} [authenticationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    loginWithPassword(authenticationBody?: AuthenticationBody, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary Logout from bonusx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    logout(options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {AdminLoginRequest} [adminLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    magicLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary Registration with email and password
     * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: RawAxiosRequestConfig): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary User can request an email to change their password
     * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: RawAxiosRequestConfig): AxiosPromise<SendForgotPasswordEmail200Response>;

    /**
     * 
     * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    verifyAccount(options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI implements AuthenticationApiInterface {
    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {AdminLoginRequest} [adminLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public adminLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).adminLogin(adminLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use this endpoint to check if the user is authenticated.
     * @summary Check user authentication status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationValidateGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationValidateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can change password and login
     * @param {InputChangePassword} [inputChangePassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public changePassword(inputChangePassword?: InputChangePassword, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).changePassword(inputChangePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can load ability rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getAbilityRules(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getAbilityRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can login through email and password
     * @param {AuthenticationBody} [authenticationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithPassword(authenticationBody?: AuthenticationBody, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithPassword(authenticationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout from bonusx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {AdminLoginRequest} [adminLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public magicLogin(adminLoginRequest?: AdminLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).magicLogin(adminLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registration with email and password
     * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).register(inputAuthenticationRegister, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can request an email to change their password
     * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyAccount(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).verifyAccount(options).then((request) => request(this.axios, this.basePath));
    }
}

